(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/router.js'); 
(function(Backbone, svs) {
  'use strict';


  svs.terms_integrity.Router = Backbone.Router.extend({
    mainView: svs.terms_integrity.app.getRegion(),

    routes: svs.core.data.routes,

    routeStart: function() {
      this.mainView.show(new svs.terms_integrity.views.InitTabs({ tab: '' }));
    },

    routeTerms: function() {
      this.mainView.show(new svs.terms_integrity.views.InitTabs({ tab: 'villkor' }));
    },

    routePersonData: function() {
      this.mainView.show(new svs.terms_integrity.views.InitTabs({ tab: 'personuppgifter' }));
    },
    routeRules: function() {
      this.mainView.show(new svs.terms_integrity.views.InitTabs({ tab: 'spelregler' }));
    },

    routeCookies: function() {
      this.mainView.show(new svs.terms_integrity.views.InitTabs({ tab: 'cookies' }));
    }
  });
})(Backbone, svs);

 })(window);